import React from 'react';
import {
    getAreaText,
    getPrice,
    getPriceRangeSuggestion,
} from '../../../common/search/realestate';
import type { RealestateAd, RealestateProjectAd } from '../../../types';

type RealestateSummaryProps = {
    ad: RealestateAd | RealestateProjectAd;
    className?: string;
};

export function RealestateSummary(props: RealestateSummaryProps) {
    const { ad, className = '' } = props;

    const areaText = getAreaText(ad);
    const priceText = getPrice(ad);
    const priceRangeText = getPriceRangeSuggestion(ad);

    if (!(areaText || priceText || priceRangeText)) {
        return null;
    }

    return (
        <div className={`${className} space-x-12 font-bold whitespace-nowrap`}>
            {areaText && <span>{areaText}</span>}
            {priceText && <span>{priceText}</span>}
            {priceRangeText && <span>{priceRangeText}</span>}
        </div>
    );
}
